import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const jobModuleRoutes = [
  {
    key: "job-module-desks",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/desks`,
    component: React.lazy(() => import("views/app-views/job-module/pages/JobDeskListPage")),
  },
  {
    key: "job-module-desk-manage",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/desks/:jobDeskId/manage`,
    component: React.lazy(() => import("views/app-views/job-module/pages/JobDeskManagePage")),
  },
  {
    key: "job-module-jobs",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/jobs`,
    component: React.lazy(() => import("views/app-views/job-module/pages/JobModule")),
  },
  {
    key: "job-module-job-new",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/jobs/new`,
    component: React.lazy(() => import("views/app-views/job-module/pages/NewJobPage")),
  },
  {
    key: "job-module-job-edit",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/jobs/:jobId/edit`,
    component: React.lazy(() => import("views/app-views/job-module/pages/JobEditPage")),
  },
  {
    key: "job-module-job-detail",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/jobs/:jobId`,
    component: React.lazy(() => import("views/app-views/job-module/pages/JobDetailPage")),
  },
  {
    key: "job-module-materials",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module/materials`,
    component: React.lazy(() => import("views/app-views/job-module/pages/MaterialMaster")),
  },
  {
    key: "job-module-root",
    exact: true,
    path: `${APP_PREFIX_PATH}/job-module`,
    component: React.lazy(() => import("views/app-views/job-module/pages/JobModuleRedirect")),
  },
];
